var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bundles-page"},[(_vm.showCheckout)?_c('div',{staticClass:"body container"},[_c('order-form',{staticClass:"form-container",attrs:{"showEditButton":false,"isPopup":_vm.isPopup}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }